import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ComplexKeyComponent } from './ComplexKey.component';

@NgModule({
    imports: [CommonModule],
    declarations: [ComplexKeyComponent],
    exports: [ComplexKeyComponent],
    providers: []
})
export class ComplexKeyModule {}
